import { action, observable } from "mobx";

export class ConsultantFavouritesStore {
  @observable ids = observable.set<string>();
  @observable loaded = false;

  @action
  setIds(ids: readonly string[]) {
    this.ids.replace(ids);
    this.loaded = true;
  }

  has(id: string): boolean {
    return this.ids.has(id);
  }

  @action
  add(id: string) {
    this.ids.add(id);
  }

  @action
  remove(id: string) {
    this.ids.delete(id);
  }

  @action
  toggle(id: string): boolean {
    if (this.ids.has(id)) {
      this.ids.delete(id);
      return false;
    }
    this.ids.add(id);
    return true;
  }
}
